'use strict';

import type { UserSunfire } from '../../Entities/User/UserSunfire';
import { EntityCollection } from '../EntityCollection';

export class UserSunfireCollection extends EntityCollection<UserSunfire> {}
